<span class="fuel-level-display" [class]=" getClass()">
  {{level}}ℓ
</span>